import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/Store";
import { ApplicationScope, ProjectAttributes } from "types/apis/applicationScopeInterfaces";

export interface ApplicationScopeState {
  applicationScopes: ApplicationScope[];
  projectAttributes: ProjectAttributes;
  loading: boolean;
  error: string | null;
  lastFetchTime: number | null;
}

const defaultState: ApplicationScopeState = {
  applicationScopes: [],
  loading: false,
  error: null,
  projectAttributes: {
    customer_type: null,
    fuel_type: null,
    meter_type: null
  },
  lastFetchTime: null
};

export const applicationScopeSlice = createSlice({
  name: 'applicationScope',
  initialState: defaultState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setApplicationScopes: (state, action: PayloadAction<ApplicationScope[]>) => {
      state.applicationScopes = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetchTime = Date.now();
    },
    setProjectAttributes: (state, action: PayloadAction<ProjectAttributes>) => {
      state.projectAttributes = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetApplicationScope: () => defaultState
  }
});

export const {
  setLoading,
  setApplicationScopes,
  setError,
  setProjectAttributes,
  clearError,
  resetApplicationScope
} = applicationScopeSlice.actions;

// Selectors
export const selectApplicationScopes = (state: RootState) => state.applicationScope.applicationScopes;
export const selectApplicationScopeLoading = (state: RootState) => state.applicationScope.loading;
export const selectApplicationScopeError = (state: RootState) => state.applicationScope.error;
export const selectProjectAttributes = (state: RootState) => state.applicationScope.projectAttributes;
export const selectLastFetchTime = (state: RootState) => state.applicationScope.lastFetchTime;


export default applicationScopeSlice.reducer;